import { render, staticRenderFns } from "./footers.vue?vue&type=template&id=841e435a&scoped=true"
import script from "./footers.vue?vue&type=script&lang=js"
export * from "./footers.vue?vue&type=script&lang=js"
import style0 from "./footers.vue?vue&type=style&index=0&id=841e435a&prod&scoped=true&lang=css"
import style1 from "./footers.vue?vue&type=style&index=1&id=841e435a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841e435a",
  null
  
)

export default component.exports